import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import CreatableSelect from "react-select/creatable";
import DraggableComponent from "../../Components/DraggableComponent";
import SelectField from "../../Components/SelectField";
import ToggleSwitch from "../../Components/ToggleSwitch";
import InputField from "../../Components/InputField";
import CreatableReactSelect from "../../Components/CreatableReactSelect";
import { useFormik } from "formik";
import * as Yup from "yup";
import ReactSelectField from "../../Components/ReactSelectField";


const AddNewField = ({ getNewField, availableOptions, isExisting }: any) => {
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const buttonRef = useRef<HTMLButtonElement>(null);
  
  const commonFields = [...(!isExisting ? [] : ["Existing"]), "Text", "Number", "Email", "Password", "Dropdown"];
  const validationSchema = Yup.object().shape({
    isMandatory: Yup.string().required("Select Optional/Mandatory"),
    fieldType: Yup.string().required("Field Type is required"),
    fieldName: Yup.string().when("fieldType", (fieldType, schema) => 
      fieldType?.[0] !== "Existing" ? schema.required("Field Name is required"): schema.notRequired()
    ),
    fieldTypeValue: Yup.array().of(Yup.object()).when("fieldType", (fieldType, schema) => 
      fieldType?.[0] === "Dropdown" ? schema.min(1, "At least one dropdown option is required") : schema
    ),
    existingField: Yup.string().when("fieldType", (fieldType, schema) => 
      fieldType?.[0] === "Existing" ? schema.required("Select Existing Field") : schema.notRequired()
    ),
    isDependent: Yup.boolean(),
    dependentFieldData: Yup.string()
    .nullable()
    .notRequired()
    .when("isDependent", {
      is: true,
      then: (schema) => schema.required("Dependent Field Name is required"),
    }),
  dependentField: Yup.string()
    .nullable()
    .notRequired()
    .when("isDependent", {
      is: true,
      then: (schema) => schema.required("Dependent Field Value is required"),
    }),
  });

  const formik = useFormik({
    initialValues: {
      fieldType: "",
      fieldName : "",
      existingField: null,
      fieldTypeValue: [],
      isMandatory: "",
      isLoaded: false,
      isDependent: false,
      dependentFieldData: "",
      dependentField: null,
      pictureRequired: false,
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      onSubmitForm(values);
      resetForm();
      setShowPopup(false);
    },
  });


  useEffect(() => {
    const availableOptions = formik.values.fieldTypeValue || [];
    const dependentValue: any = formik.values.dependentFieldData;
    const isDependentStillValid = availableOptions.some(
      (option: any) => option.value === dependentValue
    );

    if (!isDependentStillValid) {
      formik.setFieldValue("dependentFieldData", "");
    }
  }, [formik.values.fieldTypeValue, formik.values.dependentFieldData]);


  const onSubmitForm = (values: any) => {

    const newField = {
      fieldType: values.fieldType,
      fieldName: values.fieldName,
      masterFieldId: values.existingField,
      fieldTypeValue: values.fieldTypeValue,
      isMandatory: values.isMandatory === "Mandatory" ? true : false,
      isDependent: values.isDependent,
      dependentFieldData: values.dependentFieldData,
      dependentField: values.dependentField,
      pictureRequired: values.pictureRequired,
      isLoaded: values.isLoaded,
    };

    getNewField(newField);
  };

  return (
    <>
      <button type="button" ref={buttonRef} className="btn btn-success" onClick={()=> setShowPopup(true)} >Add New Field</button>
      <Modal
        show={showPopup}
        centered
        dialogAs={DraggableComponent}
        id="devEstPopup"
        size={`lg`}
      >
        <div className="modal-content new-interchange" id="devEstContentPopup">
          <Modal.Header className="modal-header" closeButton={false}>
            <h5 className="modal-title mt-0">Add New Field</h5>
            <button
              type="button"
              className="isModal"
              data-dismiss="modal"
              style={{ marginLeft: "0px", background: "none" }}
              aria-label="Close"
              onClick={() => {
                setShowPopup(false);
                formik.resetForm();
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </Modal.Header>
          <form onSubmit={formik.handleSubmit}>
            <div className="modal-body">
              <div className="row mb-3">
                <div className="col-md-6 mb-4">
                  <SelectField
                    placeholder="Select Optional/Mandatory"
                    name="isMandatory"
                    className="form-select"
                    value={formik.values.isMandatory}
                    onChange={(e:any) => formik.setFieldValue("isMandatory", e.target.value)}
                  >
                    <option value="" disabled>Select</option>
                    <option value="Mandatory" >Mandatory</option>
                    <option value="Optional" >Optional</option>
                  </SelectField>
                  {formik.touched.isMandatory && formik.errors.isMandatory && (
                      <small className="ms-2 text-danger fw-700">{formik.errors.isMandatory}</small>
                    )}
                </div>
              </div>
              <div className={`row mb-3`}>
                <div className="col-md-6 mb-0">
                  <SelectField
                    placeholder="Field Type"
                    name="fieldType"
                    className="form-select"
                    value={formik.values.fieldType}
                    onChange={(e:any) => formik.setFieldValue("fieldType", e.target.value)}
                    disabled={!formik.values.isMandatory}
                  >
                    <option value="" disabled>Select Field Type</option>
                    {commonFields.map((field, index) => (
                      <option key={index} value={field}>
                        {field}
                      </option>
                    ))}
                  </SelectField>
                  {formik.touched.fieldType && formik.errors.fieldType && (
                      <small className="ms-2 text-danger fw-700">{formik.errors.fieldType}</small>
                    )}
                </div>
                <div className={`col-md-6`}>
                  {formik.values.fieldType === "Existing" ? <>
                    <SelectField
                      placeholder="Select From Existing Field"
                      name="existingField"
                      className="form-select"
                      value={formik.values.existingField || ""}
                      onChange={(e:any) => formik.setFieldValue("existingField", e.target.value)}
                    >
                      <option value="" disabled>Select Existing Field</option>
                      {availableOptions.map((field: any, index: any) => (
                        <option key={index} value={field?.masterFieldId}>
                          {field.fieldName}
                        </option>
                      ))}
                    </SelectField>
                    {formik.touched.existingField && formik.errors.existingField && (
                        <small className="ms-2 text-danger fw-700">{formik.errors.existingField}</small>
                      )}
                  </> :
                  <>
                    <InputField
                      type="text"
                      name="fieldName"
                      className="form-control"
                      placeholder={`Field Name`}
                      autoFocus={true}
                      value={formik.values.fieldName}
                      onChange={(e:any) => formik.setFieldValue("fieldName", e.target.value)}
                      disabled={formik.values.fieldType === ""}
                    />
                    {formik.touched.fieldName && formik.errors.fieldName && (
                        <small className="ms-2 text-danger fw-700">{formik.errors.fieldName}</small>
                      )}
                  </>}
                </div>
                <div className={`col-md-6 ${formik.values.fieldType === "" ? "d-none" : ""}`}>
                  <ToggleSwitch
                    name="pictureRequired"
                    label="Image Required"
                    checked={formik.values.pictureRequired}
                    onChange={() => formik.setFieldValue("pictureRequired", !formik.values.pictureRequired)}/>
                </div>
              </div>
              {formik.values.fieldType === "Dropdown" && 
                <div className="row align-item-center mt-4 mb-2">
                  <div className="col-md-6">
                    <CreatableReactSelect
                      name="fieldTypeValue"
                      isMulti
                      options={[]}
                      value={formik.values.fieldTypeValue}
                      onChange={(selected: any) => formik.setFieldValue("fieldTypeValue", selected)}
                      placeholder="Create Dropdown Options"
                    />
                    {formik.touched.fieldTypeValue && formik.errors.fieldTypeValue && (
                        <small className="ms-2 text-danger fw-700">{formik.errors.fieldTypeValue}</small>
                      )}
                    <small className="ms-2 fst-italic">
                      Press enter to add new option
                    </small>
                  </div>
                  <div className="col-md-6 mt-0">
                    <ToggleSwitch
                      name="isDependent"
                      label="Dependent field required?"
                      checked={formik.values.isDependent}
                      onChange={() => formik.setFieldValue("isDependent", !formik.values.isDependent)}
                    />
                  </div>
                </div>}
                {formik.values.fieldType === "Dropdown" && formik.values.isDependent && 
                <div className="row mt-4">
                    <div className="col-md-6 mb-0">
                      <SelectField
                        name="dependentFieldData"
                        placeholder="Dependent Field Data"
                        value={formik.values.dependentFieldData || ""}
                        onChange={(e:any) => formik.setFieldValue("dependentFieldData", e.target.value)}
                      >
                      <option value="" disabled>Select</option>
                      {formik.values.fieldTypeValue.map((field: any, index: any) => (
                        <option key={index} value={field?.value}>
                          {field.label}
                        </option>
                      ))}
                    </SelectField> 
                      {formik.touched.dependentFieldData && formik.errors.dependentFieldData && (
                          <small className="ms-2 text-danger fw-700">{formik.errors.dependentFieldData}</small>
                        )}
                    </div>
                    <div className="col-md-6 mb-0">
                      <InputField
                        type="text"
                        name="dependentField"
                        className="form-control"
                        placeholder="Dependent Field Name"
                        value={formik.values.dependentField}
                        onChange={(e:any) => formik.setFieldValue("dependentField", e.target.value)}
                      />
                      {formik.touched.dependentField && formik.errors.dependentField && (
                          <small className="ms-2 text-danger fw-700">{formik.errors.dependentField}</small>
                    )}
                     <small className="ms-2 fst-italic">
                     as Text Field
                    </small>
                    </div>
                   
                  </div>}
                  <div className={`row g-3 align-item-center my-2`}> 
                    <div className="col-lg-12 d-flex justify-content-end align-items-end">
                      <button type="submit" className="btn btn-dark d-flex align-items-center">Save</button>
                      <button type="button" className="btn btn-outline-light ms-1" onClick={()=> {
                        setShowPopup(false);
                        formik.resetForm();
                      }}>Cancel</button>
                    </div>
                  </div>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};
export default AddNewField;
